// extracted by mini-css-extract-plugin
module.exports = {"container":"container-3faHj","html":"html-27eQv","reject":"reject-3X1aP","notice":"notice-1hB0Y","error":"error-2QseA","time":"time-2rvtV"};